import { ColorTranslator } from 'colortranslator'

export interface ShadeIterator {
  next(): string
}

export function iterateShades(color: string, count: number): ShadeIterator {
  const hsl = {
    ...new ColorTranslator(color).HSLObject,
    L: 10,
  }
  return {
    next() {
      hsl.L += 80 / count
      return new ColorTranslator(hsl).HEX
    },
  }
}
